import { createContext, useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { usePortalMe, type PortalUser } from './hooks/use-portal';

interface PortalAuthValue {
  user: PortalUser | undefined;
  isLoading: boolean;
}

const PortalAuthContext = createContext<PortalAuthValue | null>(null);

export function usePortalAuth(): PortalAuthValue {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('usePortalAuth must be used within PortalAuthContext');
  return ctx;
}

/** Route guard: redirects to the portal login page when no partner session exists. */
export function PortalRequireAuth(): JSX.Element {
  const meQuery = usePortalMe();

  if (meQuery.isPending) {
    return <div className="flex min-h-[100dvh] items-center justify-center text-sm text-muted-foreground">…</div>;
  }
  if (meQuery.isError) {
    return <Navigate to="/portal/login" replace />;
  }

  return (
    <PortalAuthContext.Provider value={{ user: meQuery.data?.data, isLoading: false }}>
      <Outlet />
    </PortalAuthContext.Provider>
  );
}
